import React from 'react';

const DoesNotBelongsToSymbol = () => {
	return (
		<>
			<div className="does-not-belongs-to-symbol">&#8713;</div>
		</>
	);
};

export default DoesNotBelongsToSymbol;
